import { exchangePrivyToken } from "@/lib/auth/privyExchange";
import { $apiV1 } from "@plugins/axios";
import { firebaseAuth } from "@plugins/firebase";
import { store } from "@store";
import { signInWithCustomToken, getIdToken } from "firebase/auth";
import { cookies } from "@/plugins/useCookies";
import { useAuthStore } from "@/plugins/2.pinia/modules/auth";

const API = {
  login: {
    particle: "/user/particle-login",
  },
};

export const loginByParticle = async (payload) => {
  try {
    const res = await $apiV1.post(API.login.particle, payload);

    return res.data;
  } catch (error) {
    // Axios errors may contain the Particle credential in request configuration.
    // Network failures have no response; preserve the original error for callers.
    throw error?.response?.data || error;
  }
};

export const loginFirebaseByToken = async (token) => {
  try {
    const authStore = useAuthStore(store);

    const userCredential = await signInWithCustomToken(firebaseAuth, token);
    const user = userCredential.user;

    const idToken = await user.getIdToken();
    if (firebaseAuth.currentUser !== user) return null;
    const payload = JSON.parse(atob(idToken.split(".")[1]));
    // Fake expiry time = now + 6 minutes
    // payload.exp = Math.floor((Date.now() + 6 * 60 * 1000) / 1000);

    authStore.accessToken = idToken;
    authStore.tokenExpiresAt = payload.exp * 1000 - 5 * 60 * 1000;

    return user;
  } catch (error) {
    // Do not log provider errors, which can contain credential-bearing requests.
    throw error;
  }
};

export const refreshToken = async () => {
  const user = firebaseAuth.currentUser;
  if (user) {
    const authStore = useAuthStore(store);

    const idToken = await getIdToken(user, true);
    if (firebaseAuth.currentUser !== user) return null;

    const payload = JSON.parse(atob(idToken.split(".")[1]));
    // Fake expiry time = now + 6 minutes
    // payload.exp = Math.floor((Date.now() + 6 * 60 * 1000) / 1000);
    console.log("refreshToken");
    authStore.accessToken = idToken;
    authStore.tokenExpiresAt = payload.exp * 1000 - 5 * 60 * 1000;

    return idToken;
  }
  return null;
};

export const loginByPrivy = accessToken => exchangePrivyToken({baseUrl: import.meta.env.VITE_API_V1_URL, accessToken});
